import {Component} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';

import {Role} from '../../helpers/role';

@Component({
    standalone: false,
  selector: "inq-sso",
  templateUrl: 'inqSso.component.html'
})

export class InqSsoComponent {
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public userService: UserService,
    public authenticationService: AuthenticationService,
    public alertService: AlertService) {
    const token = route.snapshot.queryParams['token'];
    this.authenticationService.loginInq(token).subscribe(
      data => {
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        let returnUrl = this.route.queryParams['value']['returnUrl'];
        if (returnUrl) {
          this.router.navigateByUrl(returnUrl);
        } else if (currentUser.role == Role.KingAdmin) {
          this.router.navigate(['/tenants']);
        } else if (currentUser.role == Role.Training) {
          this.router.navigate(['/training']);
        } else if (currentUser.role == Role.Survey) {
          this.router.navigate(['/assessments']);
        } else if (currentUser.role == Role.Vendor) {
          this.router.navigate(['/projects']);
        } else {
          this.router.navigate(['']);
        }
      },
      error => {
        
      });

  }
}
